import reviewer1 from "../assets/images/manOne.png";
import reviewer2 from "../assets/images/manTwo.png";
import reviewer3 from "../assets/images/womenOne.jpg";
import reviewer4 from "../assets/images/womenTwo.png";
import reviewer5 from "../assets/images/manThree.png";
import reviewer6 from "../assets/images/manFour.png";
import reviewer7 from "../assets/images/womenThree.png";
import reviewer8 from "../assets/images/womenFour.png";
import reviewer9 from "../assets/images/manFive.png";
import reviewer10 from "../assets/images/manSix.png";
import reviewer11 from "../assets/images/womenFive.png";
import reviewer12 from "../assets/images/womenSix.png";
import reviewer13 from "../assets/images/manSeven.png";
import reviewer14 from "../assets/images/manEight.png";
import reviewer15 from "../assets/images/womenSeven.png";
import reviewer16 from "../assets/images/womenEight.jpg";

export const reviews = [
    { 
      en: { name: "Ahmed Khaled", comment: "Amazing service! The gift was delivered on time and beautifully wrapped." },
      ar: { name: "أحمد خالد", comment: "خدمة مذهلة! وصلت الهدية في الوقت المحدد وكانت مغلفة بشكل رائع." },
      image: reviewer1
    },
    { 
      en: { name: "Sami Al-Dosari", comment: "A wonderful experience! My friend absolutely loved the gift." },
      ar: { name: "سامي الدوسري", comment: "تجربة رائعة! صديقتي أحبت الهدية كثيرًا." },
      image: reviewer2
    },
    { 
      en: { name: "Nour Al-Atibi", comment: "Perfectly wrapped and excellent quality gifts!" },
      ar: { name: "نور العتيبي", comment: "تغليف مثالي وهدايا بجودة ممتازة!" },
      image: reviewer3
    },
    { 
      en: { name: "Layla Hassan", comment: "Exceeded my expectations! I’ll definitely order again." },
      ar: { name: "ليلى حسن", comment: "فاقت توقعاتي! سأطلب مرة أخرى بالتأكيد." },
      image: reviewer4
    },
    { 
      en: { name: "Ziad Al-Shammari", comment: "Great service and the packaging was very elegant." },
      ar: { name: "زياد الشمري", comment: "خدمة رائعة والتغليف كان أنيقًا جدًا." },
      image: reviewer5
    },
    { 
      en: { name: "Khaled Al-Basri", comment: "Fast delivery and fantastic gifts! Highly recommended." },
      ar: { name: "خالد البصري", comment: "توصيل سريع وهدايا رائعة! أنصح بها بشدة." },
      image: reviewer6
    },
    { 
      en: { name: "Yasmin Al-Kilani", comment: "A perfect gift for any occasion! Loved the variety." },
      ar: { name: "ياسمين الكيلاني", comment: "هدية مثالية لأي مناسبة! أحببت تنوع الخيارات." },
      image: reviewer7
    },
    { 
      en: { name: "Hind Al-Abed", comment: "Amazing experience! The attention to detail is impressive." },
      ar: { name: "هند العابد", comment: "تجربة مذهلة! الاهتمام بالتفاصيل رائع جدًا." },
      image: reviewer8
    },
    { 
      en: { name: "Rami Al-Saadi", comment: "One of the best purchases I’ve made. Highly recommended!" },
      ar: { name: "رامي السعدي", comment: "واحدة من أفضل المشتريات التي قمت بها. أوصي بها بشدة!" },
      image: reviewer9
    },
    { 
      en: { name: "Nader Al-Rifai", comment: "Great value for the price! Will definitely buy again." },
      ar: { name: "نادر الرفاعي", comment: "قيمة رائعة مقابل السعر! سأشتري مرة أخرى بالتأكيد." },
      image: reviewer10
    },
    { 
      en: { name: "Sara Al-Majid", comment: "Excellent quality! The gift was exactly as described." },
      ar: { name: "سارة المجد", comment: "جودة ممتازة! الهدية كانت تمامًا كما تم وصفها." },
      image: reviewer11
    },
    { 
      en: { name: "Mirna Al-Hussein", comment: "Fantastic service! I’ll always order from here." },
      ar: { name: "ميرنا الحسين", comment: "خدمة رائعة! سأطلب دائمًا من هنا." },
      image: reviewer12
    },

    { 
        en: { name: "Omar Al-Farsi", comment: "Absolutely amazing! The quality and service were top-notch." },
        ar: { name: "عمر الفارسي", comment: "رائع للغاية! الجودة والخدمة كانت على أعلى مستوى." },
        image: reviewer13
      },
      { 
        en: { name: "Tariq Al-Jabri", comment: "Best gift shopping experience! Everything was perfect." },
        ar: { name: "طارق الجابري", comment: "أفضل تجربة لشراء الهدايا! كل شيء كان مثاليًا." },
        image: reviewer14
      },
      { 
        en: { name: "Lina Al-Sheikh", comment: "Highly satisfied! I will definitely recommend this to my friends." },
        ar: { name: "لينا الشيخ", comment: "راضٍ جدًا! سأوصي بهذه الخدمة لأصدقائي بالتأكيد." },
        image: reviewer15
      },
      { 
        en: { name: "Maha Al-Tamimi", comment: "Superb service! The gift was beyond my expectations." },
        ar: { name: "مها التميمي", comment: "خدمة رائعة! الهدية كانت أفضل مما توقعت." },
        image: reviewer16
      }
    
  ];
  

  